module.exports = __webpack_public_path__ + "img/discount_popup.92f6fc16.png";